import React from 'react';
import { Box } from '@material-ui/core/index';

import EmptyState from 'src/components/EmptyState';
import useGetRequest from 'src/hooks/useGetRequest';

import { WIDGET_DETAILS_BY_WIDGET_TYPE } from 'src/views/constants/widgetConstants';
import { Field, Widget, WidgetPayload } from 'src/types';

interface Props {
  selectedWidget?: Widget,
  workflowId: string,
  perspectiveId: string,
  deleteWidget: (widgetId: string) => Promise<void>,
  saveWidget: (widgetId: string, widget: WidgetPayload) => Promise<void>,
}

const Inspector = ({
  selectedWidget,
  workflowId,
  perspectiveId,
  deleteWidget,
  saveWidget,
}: Props) => {
  const { result: perspective, isLoading: perspectiveLoading } = useGetRequest({
    url: `/automatic/workflows/${workflowId}/perspectives/${perspectiveId}/`,
    initialResult: {},
    shouldFetchOnInitialRender: Boolean(selectedWidget)
  });
  const { result: table, isLoading: tableLoading } = useGetRequest({
    url: `/automatic/workflows/${workflowId}/table/`,
    initialResult: { fields: [] },
  });

  const fieldByFieldId: Record<string, Field> = {};

  table.fields.forEach((field: Field) => {
    fieldByFieldId[field.id] = field;
  });

  if (perspectiveLoading || tableLoading) return null;
  if (!selectedWidget) return <EmptyState text="No widget selected" />;

  const Component = WIDGET_DETAILS_BY_WIDGET_TYPE[selectedWidget.type].inspectorComponent;

  return (
    <Box pt={2}>
      <Component
        selectedWidget={selectedWidget}
        perspectiveType={perspective.perspectiveType}
        // widgets={widgets}
        // refreshTable={refreshTable}
        // fields={fields}
        workflowId={workflowId}
        saveWidget={saveWidget}
        deleteWidget={deleteWidget}
        // perspectiveId={perspectiveId}
        // getPerspective={getPerspective}
        selectedWidgetField={selectedWidget ? fieldByFieldId[selectedWidget.fieldId] : undefined}
      />
    </Box>
  );
};

export default Inspector;
